import React from "react";
import "./HistoryDisplay.scss";
import HistoryResponce from "./HistoryResponce";

const HistoryChatDisplay = ({
  setIsLoading,
  isLoading,
  responceData,
  query,
  printPDF,
  loadingIndex,
  setResponceData,
  isHistory,
  page,
  newChatStart
}) => {
console.log("HistoryChatDisplay responceData:", responceData);
  return (
    <div className="response-cont">
      {responceData.map((message, index) => (
        <HistoryResponce
          key={index}
          message={message}
          isLoading={isLoading}
          setIsLoading={setIsLoading}
          index={index}
          printPDF={printPDF}
          loadingIndex={loadingIndex}
          setResponceData={setResponceData}
          isHistory={isHistory}
          page={page}
          newChatStart={newChatStart}
        />
      ))}
    </div>
  );
};

export default HistoryChatDisplay;
